import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader, showErrorMessage, showSuccessMessage, showWarningMessage,
} from './../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  API_URL,
  showErrorMessage,
  showWarningMessage,
};

export const ROLEPERMISSIONAPI = `${API_URL}/api/RolePermission`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const rolePermissionActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTER_DATA'),
  get_role_permissions: createRequestActionTypes('GET_ROLE_PERMISSION'),
  post_role_permission: createRequestActionTypes('POST_ROLE_PERMISSION'),
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/constants/ApiConstants.js